import { Pricing, withModal } from 'components/Modal';
import { getPlans } from 'modules/pricing/selectors';
import { actions } from 'modules/user';
import { getMerchantProp } from 'modules/user/selectors/merchant';
import { connect } from 'react-redux';
import {
  compose,
  onlyUpdateForKeys,
  withHandlers,
  withPropsOnChange,
} from 'recompose';
import { createStructuredSelector } from 'reselect';
import view from './view';

const mapStateToProps = createStructuredSelector({
  plans: getPlans,
  role: getMerchantProp('role'),
  isTest: getMerchantProp('testStore'),
  platform: getMerchantProp('platform'),
  createdAt: getMerchantProp('createdAt'),
  isPrivateShopify: getMerchantProp('isPrivateShopify'),
  merchantID: getMerchantProp('merchantID'),
});

export default compose(
  connect(mapStateToProps, actions),
  onlyUpdateForKeys(['title']),
  withModal('pricing', Pricing),
  withPropsOnChange(['plans'], ({ plans = [] }) => ({
    shouldDisplayUpgradeLink: !!plans.find(
      ({ isCurrent, name }: any) => isCurrent && name !== 'Enterprise'
    ),
  })),
  withPropsOnChange(['user'], ({ user }) => ({
    merchants:
      user &&
      user.merchants.reduce(
        (acc, m) => ({
          ...acc,
          [m.merchantID || m.onboardingID]: m.merchantName,
        }),
        {}
      ),
  })),
  withHandlers({
    onUpgradeClick:
      ({ showModal }) =>
      () =>
        showModal('pricing'),
    goToAdmin:
      ({ history }) =>
      () =>
        history.push('/admin'),
    goToArchive:
      ({ history }) =>
      () => {
        window.location.href = 'https://dashboard-archive-v1.findify.io';
      },
  })
)(view);
